import { EnumItemModel } from './ItemModels';

export enum EReportFilterType {
    Full = 0,
    FullOrg = 1,
    FullParent = 2,
    ParentById = 3,
    OrgById = 4
}

export const ReportFilterTypeEnumItems:
    ReadonlyArray<EnumItemModel<EReportFilterType>> = [
        { text: 'All', value: EReportFilterType.Full },
        { text: 'All Organizations', value: EReportFilterType.FullOrg },
        { text: 'All Parents', value: EReportFilterType.FullParent },
        { text: 'Specific Organization', value: EReportFilterType.OrgById },
        { text: 'Specific Parent', value: EReportFilterType.ParentById }
    ];
